
<v-dialog ref="dialog" v-model="show_dialog" :return-value.sync="time" persistent width="290px">
	<template #activator="{ on, attrs }">
		<v-text-field
			v-model="time"
			outlined
			:label="label"
			:readonly="true"
			v-bind="attrs"
			:background-color="!toggled ? null : readonlyMode ? '#ECECEC' : null"
			:append-icon="toggled ? (readonlyMode ? 'mode_edit' : 'done') : null"
			v-on="!toggled ? on : readonlyMode ? null : on"
			@click:append="readonlyMode ? edit() : finished()"
		></v-text-field>
	</template>
	<v-time-picker
		v-if="show_dialog"
		v-model="time"
		full-width
		format="24hr"
		:allowed-minutes="[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55]"
		:max="max"
		:min="min"
		@input="!toggled ? OnInput : null"
	>
		<v-spacer></v-spacer>
		<v-btn text color="primary" @click="show_dialog = false">Cancel</v-btn>
		<v-btn text color="primary" @click="$refs.dialog.save(time)">OK</v-btn>
	</v-time-picker>
</v-dialog>
